import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import extractBeforeDash from '@acorn-portal/shared/src/utils/extractBeforeDash';
import { isProduct } from './is-product';

export const getEnvProduct = (): Product => {
	const extractProduct: string = extractBeforeDash(import.meta.env.VITE_JOURNEY || '');

	if (!isProduct(extractProduct)) {
		throw new Error('No product env variable set; consider setting "VITE_JOURNEY"');
	}

	return extractProduct;
};
